export default __webpack_public_path__ + "static/media/7-CarstenSlyk.acc35ac9.png";